export default __webpack_public_path__ + "static/media/blue_star.0be4feb4.svg";